// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener('DOMContentLoaded', function() {
var slideshowElement = document.getElementById('tb-slideshow');
if (slideshowElement) {
  document.body.classList.add('common-home');
}
});


// ========================== BACK TO TOP ========================== 
$(window).scroll(function () {
  if ($(this).scrollTop() >= 50) {
    $('#return-to-top').fadeIn(200);
  } else {
    $('#return-to-top').fadeOut(200);
  }
});
$('#return-to-top').click(function () {
  $('body,html').animate({
    scrollTop: 0
  }, 500);
});


// ========================== MENU-CLICK HIDE MENU DROPDOWN ==========================
$(document).ready(function() {
  $('.list-menu__item').on('click', function() {
    $('#Details-menu-drawer-container').removeAttr('open');
    $('.header__icon').attr('aria-expanded', 'false');
    $('body').removeClass('overflow-hidden-tablet');
    $('.menu-opening').removeClass('menu-opening');
  });
});


// ========================== CUSTOMERS OWL-CAROUSEL ==========================
var tb_customer = $(document).ready(function(){
  $('#tb-customers .tb-customer-wrapper').owlCarousel({
      items : 4,
      margin: 30,
      nav: false,
      dots: true,
      loop: false,
      responsive: {
              0:{
                  items:1
              },
              631:{
                  items:2
              },
              992:{
                  items:3
              },
              1200:{
                  items:4    
              }
          }
  });
});


// ========================== RELATED PRODUCT OWL-CAROUSEL ==========================
var tb_related_product = $(document).ready(function(){
  $('#productThumbs').owlCarousel({
      items : 4,
      margin: 15,
      nav: true,
      dots: false,
      loop: false,
      responsive: {
              0:{
                  items:2
              },
              481:{
                  items:3
              },
              576:{
                  items:4
              },
              768:{
                  items:5
              },
              992:{
                  items:3
              },
              1300:{
                  items:4  
              }
          }
  });
});


// ========================== FOOTER TOGGLE ==========================
function footerToggle() {
    if ($(window).width() < 992) {
        $(".tb-footer-center .footer-column h5").addClass("toggle");
        $(".tb-footer-center .footer-column h5.toggle").unbind("click");
        var Accordions = function (el, multiple) {
            this.el = el || {};
            this.multiple = multiple || false;
            var link = this.el.find('.toggle');
            link.on('click', { el: this.el, multiple: this.multiple }, this.dropdown)
        }
        Accordions.prototype.dropdown = function (e) {
            var $el = e.data.el;
            $this = $(this),
                $next = $this.next();
            $next.slideToggle();
            $this.parent().toggleClass('active');
            if (!e.data.multiple) {
                $el.find('.tb-footer-center .footer-column').not($next).slideUp().parent().removeClass('active');
            };
        }
        var accordions = new Accordions($('.tb-footer-center .footer-column'), false);
    } else {
        $(".tb-footer-center .footer-column h5.toggle").unbind("click");
        $(".tb-footer-center .footer-column h5").removeClass('toggle');
    }
}
$(document).ready(function () { footerToggle(); });
$(window).resize(function () { footerToggle(); });



// ========================== RELATED PRODUCT ==========================
$(document).ready(function() {
  // Add active class to the first image by default
  $('.tb-related-product:first').parent().addClass('active');

  // Attach click event listener to each related product thumbnail
  $('.tb-related-product').click(function() {
    // Remove active class from all related product thumbnails and their parent containers
    $('.tb-related-product').parent().removeClass('active');

    // Add active class to the clicked related product thumbnail and its parent container
    $(this).addClass('active').parent().addClass('active');

    // Get the URL of the clicked thumbnail's image
    var thumbnailSrc = $(this).attr('src');

    // Update the source attribute of the main product image
    // $('.zoom').css('background-image', 'url(' + thumbnailSrc + ')');
    $('#productPhotoImg').attr('src', thumbnailSrc);
  });
});


document.addEventListener('DOMContentLoaded', function() {
    // Add event listener for mouseenter event on .zoom element
    var zoomElement = document.querySelector('.zoom');
    if (zoomElement) {
        zoomElement.addEventListener('mouseenter', function() {
            // Get the URL of the main product image
            var img_url = document.getElementById('productPhotoImg').getAttribute('src');
            // Set background image of .zoom element to the main product image
            this.style.backgroundImage = 'url(' + img_url + ')';
        });

        // Add event listener for mouseleave event on .zoom element
        zoomElement.addEventListener('mouseleave', function() {
            // Remove background image when mouse leaves the .zoom element
            this.style.backgroundImage = 'none';
        });
    }
});



function zoom(e){
  var zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetY = e.touches[0].pageY
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}